import { SxProps } from '@mui/system';
import Spacings from '../components/ds/theme/common/spacings';
import typography from '../components/ds/theme/common/typography';
import { solTheme } from '../components/ds/theme/SolThemeProvider';

const customScrollbar = {
  '&::-webkit-scrollbar': {
    width: 8,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'neutral.80',
    borderRadius: Spacings.small2,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: 'neutral.65',
  },
};

const srOnly: SxProps = {
  position: 'absolute',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: '1px',
  width: '1px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
};

const inputTypePassword = {
  fontFamily: 'password',
  letterSpacing: '4px',
  [solTheme.breakpoints.down('sm')]: {
    height: '20px',
    fontSize: typography?.body2?.fontSize,
  },
};

const dropdownBoxShadow = {
  boxShadow: '4px 4px 20px 0px rgba(6, 37, 113, 0.16)',
};

export default {
  customScrollbar,
  srOnly,
  inputTypePassword,
  dropdownBoxShadow,
};
